<template>
	<div class="sidebar-block">
<!-- 		<div class="block-sidebar-item remote-app" @click="navRemote">
			<div class="bg"></div>
			<img :src="require('@/static/img/icon-download-remote.png')" class="img">
			<div class="download">DOWMLOAD</div>
		</div> -->
		<div class="block-sidebar-item" @click="onMax">
			<span class="iconfont icon-max"></span>
		</div>
		<div class="block-sidebar-item" @click="onTele">
			<span class="iconfont icon-a-telegram"></span>
		</div>
		<div class="block-sidebar-item" @click="onWhatapp">
			<span class="iconfont icon-whatsapp"></span>
		</div>
		<div class="block-sidebar-item" @click="scrollToTop" v-show="scrollTopVal">
			<span class="iconfont icon-shangjiantou"></span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'tvSideBar',
		components: {},
		data() {
			return {
				scrollTopVal: 0
			};
		},
		computed: {},
		methods: {
			navRemote() {
				this.$router.push({
					path: '/remote'
				})
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},
			scrollTop() {
				this.$nextTick(() => {
					this.scrollTopVal = document.documentElement.scrollTop || document.body.scrollTop || window
						.pageYOffset
				})
			},
			onTele() {
				const username = 'AuroraMCPlayer'
				const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
				const webUrl = `https://t.me/${username}`

				// 桌面端直接打开网页版
				if (!/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
					return window.open(webUrl, '_blank')
				}

				// iOS 使用隐藏iframe方案
				if (isIOS) {
					const iframe = document.createElement('iframe')
					iframe.style.cssText = 'display:none;width:0;height:0;'
					iframe.src = `tg://resolve?domain=${username}`
					document.body.appendChild(iframe)

					setTimeout(() => {
						document.body.removeChild(iframe)
						if (!document.hidden) {
							// 如果App未安装，跳转网页版
							window.location.href = webUrl
						}
					}, 300)
				} else {
					window.location.href = `tg://resolve?domain=${username}`
					setTimeout(() => {
						if (!document.hidden) window.open(webUrl, '_blank')
					}, 400)
				}
			},
			onMax () {
				const username = 'AURORA'
				const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
				const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
				const webUrl = `https://web.max.ru/${username}`
				
				// 桌面端直接打开网页版
				if (!isMobile) {
					window.open(webUrl, '_blank')
					return
				}
				
				const maxAppUrl = `max://chat?username=${username}`
				
				if (isIOS) {
					const iframe = document.createElement('iframe')
					iframe.style.cssText = 'display:none;width:0;height:0;'
					iframe.src = maxAppUrl
					document.body.appendChild(iframe)
				
					setTimeout(() => {
						document.body.removeChild(iframe)
						// 如果 App 未安装，跳转网页版
						if (!document.hidden) {
							window.location.href = webUrl
						}
					}, 300)
				} else {
					// Android 直接尝试跳转
					window.location.href = maxAppUrl
					setTimeout(() => {
						if (!document.hidden) {
							window.open(webUrl, '_blank')
						}
					}, 400)
				}
			},
			onWhatapp() {
				const webUrl = 'https://wa.me/79315988108'

				const hiddenLink = document.createElement('a')
				hiddenLink.style.display = 'none'
				hiddenLink.href = webUrl
				hiddenLink.target = '_blank'
				console.log(hiddenLink);
				document.body.appendChild(hiddenLink);
				hiddenLink.click()

				setTimeout(() => {
					document.body.removeChild(hiddenLink);
				}, 300)
			}
		},
		created() {

		},
		mounted() {
			window.addEventListener('scroll', this.scrollTop, true)
		},
		updated() {},
	}
</script>
<style lang='less' scoped>
	.sidebar-block {
		position: fixed;
		/* display: none; */
		right: 20px;
		bottom: 20px;
		margin-left: 680px;
		z-index: 102;
		color: #fff;

		.block-sidebar-item {
			display: flex;
			align-items: center;
			padding: 6px;
			border-radius: 8px;
			background: #1E2B29;
			text-align: center;
			margin-bottom: 16px;
			cursor: pointer;
			box-sizing: border-box;
		}

		.remote-app {
			display: block;
			position: relative;
			width: 44px;
			height: 44px;
			background: #1ef8a0;
		}

		.bg {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			border-radius: 8px;
			background: radial-gradient(#fff 0%, rgba(255, 255, 255, 0) 100%);
		}

		.iconfont {
			font-size: 32px;
		}

		.img {
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			width: 40px;
			height: 51px;
			bottom: 0px;
		}
	}

	.download {
		position: absolute;
		left: -5px;
		bottom: -10px;
		border-radius: 8px;
		padding: 3px 4px;
		color: #fff;
		background: #5832FF;
		font-size: 8px;
	}

	@media (max-width: 1500px) {
		.sidebar-block {
			left: auto;
			right: 4%;
			margin-left: 0;
		}
	}
</style>
